import api from '../../api/client';
import React from "react";
import { Row, Col, Card } from "antd";
import { Link } from "react-router-dom";
import MainCard from "../../components/Card/MainCard";
// import MainCard from "components/MainCard";
import {
  HomeOutlined,
  BankOutlined,
  ProfileOutlined,
  AppstoreOutlined,
  UserOutlined,
  SafetyOutlined,
  IdcardOutlined,
  TeamOutlined,
  BugOutlined,
} from "@ant-design/icons";

const settingsLinks = [
  {
    title: "Farm",
    path: "/farms",
    icon: <HomeOutlined style={{ fontSize: 28 }} />,
    description: "Configure farm details, location and operational settings.",
  },
  {
    title: "Company Profile",
    path: "/farm/profile",
    icon: <BankOutlined style={{ fontSize: 28 }} />,
    description: "Manage organization information and contact details.",
  },
  {
    title: "Chart of Accounts",
    path: "/accounts/chart-accounts",
    icon: <ProfileOutlined style={{ fontSize: 28 }} />,
    description: "Set up financial accounts used in transactions.",
  },
  {
    title: "Farm Items",
    path: "/farm-items",
    icon: <AppstoreOutlined style={{ fontSize: 28 }} />,
    description: "Manage inventory items such as feeds and equipment.",
  },
  {
    title: "Users",
    path: "/users",
    icon: <UserOutlined style={{ fontSize: 28 }} />,
    description: "Add and manage users who can access the system.",
  },
  {
    title: "Roles / Permissions",
    path: "/users/roles",
    icon: <SafetyOutlined style={{ fontSize: 28 }} />,
    description: "Define roles and control what users can access.",
  },
  {
    title: "Stock",
    path: "/settings/stock",
    icon: <IdcardOutlined style={{ fontSize: 28 }} />,
    description: "Update your personal account information.",
  },
  {
    title: "Stakeholders",
    path: "/stakeholders",
    icon: <TeamOutlined style={{ fontSize: 28 }} />,
    description: "Manage farmers, suppliers and other stakeholders.",
  },
  {
    title: "Animal Types",
    path: "/settings/animal-types",
    icon: <BugOutlined style={{ fontSize: 28 }} />,
    description: "Define livestock types like cattle, poultry and goats.",
  },
];

const SettingsPage = () => {
  return (
    <React.Fragment>
      <Row>
        <Col span={24}>
          <MainCard title="Settings Page" isOption>
            <Row gutter={[16, 16]}>
              {settingsLinks.map((item, index) => (
                <Col xs={24} sm={12} md={8} lg={6} key={index}>
                  <Link to={item.path}>
                    <Card hoverable style={{ height: "100%" }}>
                      <div style={{ marginBottom: 12, fontSize: 10 }}>
                        {item.icon}
                      </div>
                      <h5 style={{ marginBottom: 8 }}>{item.title}</h5>
                      <p className="text-muted">{item.description}</p>
                    </Card>
                  </Link>
                </Col>
              ))}
            </Row>
          </MainCard>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default SettingsPage;
